<div>
  <form>
    <div class="row form-group formio-component formio-component-textfield">
      <div class="col-md-{{getNumColumns()}}" *ngIf="!hideProductInfo">
        <div class="form-group">
          <label>{{productNameLabel}}</label>
          <input type="text" class="form-control" readonly value="{{productName}}">
        </div>
      </div>

      <div class="col-md-{{getNumColumns()}}">
        <div class="form-group">
          <label>{{productPriceLabel}}</label>
          <input type="text" class="form-control" readonly value="{{productPrice | currency}}">
        </div>
      </div>

      <div class="col-md-{{getNumColumns()}}" *ngIf="!hideQty" >
        <div class="form-group">
          <label>{{quantityLabel}}</label>
          <input class="form-control" type="number" min="0" max="1000" value="{{productQuantity}}" step="1" (change)="changeFn($event)">
        </div>
      </div>
    </div>
  </form>
</div>
